import { IAction } from '@r1-frontend/shared/types/Redux';

import { BP42Action } from '~/src/packages/bp42/constants/actions';

const setLoading = (state: boolean): IAction<BP42Action.Loading, { state: boolean }> => ({
    type: BP42Action.Loading,
    payload: {
        state,
    },
});

export default setLoading;
